import React from "react"
import { useLocation } from "react-router-dom"

import styled from "styled-components"

import { futureColors } from "@izettle/otto"
import { useLocalization } from "@izettle/tenko-react"

const ErrorContainer = styled.div`
  width: 640px;
  margin: auto;
  color: ${futureColors.text.default};
`

const ErrorTitle = styled.h2`
  font-size: 38px;
  margin-bottom: 16px;
`

const ErrorCode = styled.code`
  background: ${futureColors.background.groupedSecondary};
  color: ${futureColors.text.highlight};
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 14px;
`

const ErrorMessage = styled.p`
  font-size: 18px;
  color: ${futureColors.text.secondary};
`

const ErrorLink = styled.a`
  color: ${futureColors.action.secondary.text.default};
  font-size: 22px;
  &:hover,
  &:active {
    color: ${futureColors.action.secondary.text.hover};
  }
`

export const Error404 = () => {
  const location = useLocation()
  const { text } = useLocalization()
  return (
    <ErrorContainer>
      <ErrorTitle>{text("ERROR_404_TITLE")}</ErrorTitle>
      <ErrorMessage>
        {text("ERROR_404_MESSAGE", [<ErrorCode key={1}>{location.pathname}</ErrorCode>])}
      </ErrorMessage>
      <ErrorLink href="https://zettle.com">{text("GO_HOME_LINK")}</ErrorLink>
    </ErrorContainer>
  )
}
